import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';
import type { AssetSearchCriteria } from '@/api';
import { AssetService, FieldLevelSearchDto } from '@/api';
import { getModule } from 'vuex-module-decorators';
import authModule from '@/store/modules/auth';
import store from '@/store';
import { DataItemProps } from 'vuetify';
import { useRoute } from 'vue-router/composables';

type SearchParameters = AssetSearchCriteria;




const TYPING_INTERVAL = 500

export default /*#__PURE__*/_defineComponent({
  __name: 'Search-Bar',
  setup(__props) {

const route = useRoute();
const auth = getModule(authModule, store);

const timer = ref();
const assetsCount = ref(0);
const minRange = ref(0);
const maxRange = ref(0);
const assets = ref<FieldLevelSearchDto[]>([]);
const isLoading = ref(false);
const isOpen = ref(false);
const searchParameters = ref<SearchParameters>({
  page: 1,
  itemsPerPage: 20,
  textSearch: '',
  healthStatus: [],
  assetFilterType: [],
  tag: [],
  datasource: [],
  sort: [],
});

const menuClass = computed(() => (isOpen.value ? 'search-bar--menu-filled' : 'search-bar--menu-empty'));
const hasMenu = computed(() => route.name !== 'data-catalog');
const searchParamsWithDomain = computed(() => ({
  ...searchParameters.value,
  domain: auth.selectedDomain?.name,
}));
const filteredDatasets = computed(() => {
  if (searchParameters.value.textSearch) return assets.value;
  return [];
});

const closeMenu = () => {
  setTimeout(() => {
    isOpen.value = false;
  }, 200);
};

const resetSearch = () => {
  searchParameters.value.textSearch = '';
  assets.value = [];
  assetsCount.value = 0;
  minRange.value = 0;
  maxRange.value = 0;
};

const searchRequest = async () => {
  isLoading.value = true;
  const { searchAssets } = await AssetService.getAllAssets({
    requestBody: searchParamsWithDomain.value,
  });
  isOpen.value = true;
  assetsCount.value = searchParameters.value.textSearch ? searchAssets.totalElements! : 0;
  minRange.value = assetsCount.value > 0 ? 1 : 0;
  maxRange.value = assetsCount.value > 20 ? 20 : assetsCount.value;
  assets.value = searchParameters.value.textSearch ? searchAssets.data! : [];
  isLoading.value = false;
};

const handleSearch = () => {
  clearTimeout(timer.value);
  timer.value = setTimeout(searchRequest, TYPING_INTERVAL);
};

const createItemProps = (asset: FieldLevelSearchDto, index: number): Omit<DataItemProps, 'item'> & { item: FieldLevelSearchDto } => ({
  index,
  item: asset,
  select: () => false,
  isSelected: false,
  expand: () => { },
  isExpanded: false,
  isMobile: false,
});

watch(() => isOpen.value, () => {
  if (!isOpen.value) {
    resetSearch();
  }
});

return { __sfc: true,TYPING_INTERVAL, route, auth, timer, assetsCount, minRange, maxRange, assets, isLoading, isOpen, searchParameters, menuClass, hasMenu, searchParamsWithDomain, filteredDatasets, closeMenu, resetSearch, searchRequest, handleSearch, createItemProps, computed, ref, watch, AssetService, FieldLevelSearchDto, getModule, authModule, store, DataItemProps, useRoute }
}

})